/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
import {NgModule} from '@angular/core';
import {UserSearchPageModule} from './search/user-search-page.module';

@NgModule({
    imports: [UserSearchPageModule]
})
export class AdminPagesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/admin/admin-pages.module.ts